import { type ChangeEvent } from "react";
import { format } from "./format";

const DATE_PATTERN = /(\d{2})(\d{0,2})(\d{0,4})/;
const DATE_SEPARATOR = "/";

export const formatDate = (event: ChangeEvent<HTMLInputElement>) => {
    return format(event, DATE_PATTERN, DATE_SEPARATOR);
};
